import { getLocalTimeZone, now, ZonedDateTime } from "@internationalized/date"
import { type TimeValue, useTimeField } from "@react-aria/datepicker"
import { useTimeFieldState } from "@react-stately/datepicker"
import { useRef } from "react"

import type { SX } from "../../theme"
import { enLocale } from "../../utils/date"
import { Segment } from "../DateInput/DateSegments"
import { Icon } from "../Icon"
import styles from "./TimeField.module.css"

interface TimeFieldProps {
  defaultValue?: TimeValue | ZonedDateTime
  minValue?: "now"
  onChange: (value: TimeValue) => void
  sx?: SX
}

export function TimeField(props: TimeFieldProps) {
  const { defaultValue, minValue, onChange, sx } = props
  const fieldRef = useRef<HTMLDivElement>(null)

  const timeZone = getLocalTimeZone()
  const locale = enLocale()

  const state = useTimeFieldState({
    locale,
    // we only handle hours and minutes in the UI
    // to ensure this we will force default time to have seconds set to 0
    placeholderValue: now(timeZone).set({ second: 0 }),
    defaultValue,
    minValue: minValue === "now" ? now(timeZone) : undefined,
    onChange,
    shouldForceLeadingZeros: true,
  })

  const { fieldProps } = useTimeField(
    {
      "aria-labelledby": "time-field",
    },
    state,
    fieldRef,
  )

  return (
    <div className={styles.timeField} style={sx}>
      <Icon name="schedule" size="medium" color="grey11" />
      <div {...fieldProps} className={styles.segments} ref={fieldRef}>
        {state.segments.map((segment, index) => (
          <Segment key={index} segment={segment} state={state} />
        ))}
      </div>
    </div>
  )
}
